import React from "react";

import {
  ContentCard,
  ResponsiveFlex,
  Select,
  TextInput,
} from "@narmi/design_system";
import { entities, modules } from "byzantine";
import { useLocalization } from "@fluent/react";

import styles from "../Form.module.scss";
import * as formAdapters from "../../../../../../../adapters";
import LimitsDialog from "../../../../../../../../components/transfer/LimitsDialog";

import {
  useDetailsSelector,
  useLimitsForDisplay,
} from "./DetailsSelector.container";

function DetailsSelector() {
  const { l10n } = useLocalization();
  const { fedwireTemplatesEnabled, internationalWires } =
    modules.wireTemplates.useWirePermissions();

  const { wireReasons, method, form } = useDetailsSelector();

  const limits = entities.limits.useLimits();
  const limitsForDisplay = useLimitsForDisplay(limits);
  const {
    templateSelected,
    additionalDetailsRequired,
    requiresAmount,
    requiresMemo,
    requiresWireReason,
  } = modules.wireTemplates.useConditionalDetails();

  if (
    !method ||
    !templateSelected ||
    (!additionalDetailsRequired && Object.keys(limitsForDisplay).length === 0)
  ) {
    return null;
  }

  const titleForWireDetail =
    fedwireTemplatesEnabled && internationalWires
      ? l10n.getString("heading-wire-title-domestic")
      : l10n.getString("heading-wire-details");

  return (
    <ContentCard kind="bordered">
      {additionalDetailsRequired ? (
        <p className={styles.wireTemplatesFormSubHeader}>
          {titleForWireDetail}
        </p>
      ) : null}
      <ResponsiveFlex gapSize="m">
        {requiresAmount ? (
          <TextInput
            label={l10n.getString("label-wire-amount")}
            {...formAdapters.amountInput(form, "amount")}
          />
        ) : null}
        {requiresMemo ? (
          <TextInput
            label={l10n.getString("label-wire-memo")}
            {...formAdapters.input(form, "memo")}
          />
        ) : null}
        {requiresWireReason ? (
          <Select
            label={l10n.getString("label-wire-reason")}
            {...formAdapters.select(form, "wireReason")}
          >
            {wireReasons.map((reason) => {
              return (
                <Select.Item key={reason} value={reason}>
                  {reason}
                </Select.Item>
              );
            })}
          </Select>
        ) : null}
        <LimitsDialog
          type={["domestic_wire"]}
          limitsForDisplay={limitsForDisplay}
        />
      </ResponsiveFlex>
    </ContentCard>
  );
}

export default React.memo(DetailsSelector);
